import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=2b09b96f&scoped=true&"
import script from "./BookingDetail.vue?vue&type=script&lang=js&"
export * from "./BookingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=2b09b96f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09b96f",
  null
  
)

export default component.exports